<div class="contact-persons" *ngIf="contactPersons.length">

  <div class="contact-persons__headline">
    {{headline}}
  </div>
  <div class="contact-persons__contacts-wrapper">
    <div class="contact-persons__contact-item" *ngFor="let contactPerson of displayedContactPersons">
      <brt-contact-person [contactPerson]="contactPerson"></brt-contact-person>
    </div>
  </div>
  <div class="contact-persons__show-all-wrapper" [ngClass]="{'all': showAll}" *ngIf="contactPersons.length > 2">
    <div class="contact-persons__show-all">
      <brt-item-tag [before-icon]="'people'" [title]="hiddenContactPersonsCount + ' weitere ' + headline  + ' anzeigen'" (click)="toggleShowAllList()"></brt-item-tag>
    </div>
    <div class="contact-persons__hide-all">
      <brt-item-tag [before-icon]="'people'" [title]="'weniger Ansprechpersonen anzeigen'" (click)="toggleShowAllList()"></brt-item-tag>
    </div>
  </div>
</div>
